import SunExposure from "@/config/calculationModuleResults/sunExposureResultConfig";
import Accessibility from "@/config/calculationModuleResults/accessibilityResultConfig";
import MultiLayerAnalysisConfig from "@/config/multiLayerAnalysis/multiLayerAnalysisResultConfig";
import PerformanceInfosConfig from "@/config/multiLayerAnalysis/performaceInfosConfig";
import SubSelectionLayerConfig from "@/config/multiLayerAnalysis/subSelectionLayerConfig";
import { StoreState } from "@/models";
import {
  addSourceAndLayerToMap as addSourceAndLayersToMap,
  addImageSourceAndLayerToMap,
} from "@/services/map.service";
import * as turf from "@turf/turf";

import { calcAbmStatsForMultiLayer } from "@/store/scenario/abmStats";
import { calculateAmenityStatsForMultiLayerAnalysis } from "@/store/scenario/amenityStats";
import { ActionContext } from "vuex";
export default {
  async addSunExposureLayer({
    rootState,
    commit,
  }: ActionContext<StoreState, StoreState>) {
    return rootState.cityPyO.getLayer("sun_exposure").then((result) => {
      commit("sunExposureGeoJson", result.results);
      SunExposure.source.options.data = result.results;

      addSourceAndLayersToMap(
        SunExposure.source,
        SunExposure.layerConfigs,
        rootState.map
      );
    });
  },

  async addAccessibilityLayer(
    { rootState, commit }: ActionContext<StoreState, StoreState>,
    landUseType: string = "residential"
  ) {
    const layerId = `accessibility_${landUseType}`;
    const renderMode = process.env.VUE_APP_ACCESSIBILITY_RENDER_MODE || "geojson";
    if (renderMode === "raster") {
      const projectAreaResult = await rootState.cityPyO.getLayer("project_area");
      const projectArea = projectAreaResult.results || projectAreaResult;
      const [minX, minY, maxX, maxY] = turf.bbox(projectArea as any);
      const imageCoordinates = [
        [minX, maxY],
        [maxX, maxY],
        [maxX, minY],
        [minX, minY],
      ] as [
        [number, number],
        [number, number],
        [number, number],
        [number, number]
      ];

      const imageUrl = rootState.cityPyO.getLayerAssetUrl(layerId, "png");
      addImageSourceAndLayerToMap(
        "accessibility_raster_source",
        imageUrl,
        imageCoordinates,
        "accessibility_raster",
        rootState.map
      );
      return;
    }

    return rootState.cityPyO
      .getLayer(layerId)
      .then((result) => {
        // Returns GeoJSON FeatureCollection with grid cells
        // Handle both wrapped (result.results) and direct (result) formats
        const geoJsonData = result.results || result;
        commit("accessibilityGeoJson", geoJsonData);
        Accessibility.source.options.data = geoJsonData;

        addSourceAndLayersToMap(
          Accessibility.source,
          Accessibility.layerConfigs,
          rootState.map
        );
      });
  },

  async calculateStatsForMultiLayerAnalysis(): Promise<void> {
    // the timeout just gives time for the commits above to persist and the app to be rerendered
    await new Promise((resolve) => setTimeout(resolve, 500));

    await calculateAmenityStatsForMultiLayerAnalysis().then(() => {
      calcAbmStatsForMultiLayer();
      return;
    });
  },

  addMultiLayerAnalysisLayer({ rootState }, features) {
    // update layer on map
    const source = MultiLayerAnalysisConfig.source;
    source.options.data.features = features;
    addSourceAndLayersToMap(
      source,
      MultiLayerAnalysisConfig.layerConfigs,
      rootState.map
    );
  },
  addSubSelectionLayer({ state, commit, dispatch, rootState }, features) {
    // update layer on map
    const source = SubSelectionLayerConfig.source;
    source.options.data.features = features;
    addSourceAndLayersToMap(
      source,
      SubSelectionLayerConfig.layerConfigs,
      rootState.map
    );
  },
  addMultiLayerPerformanceInfos(
    { state, commit, dispatch, rootState },
    features
  ) {
    // update layer on map
    const source = PerformanceInfosConfig.source;
    source.options.data.features = features;
    addSourceAndLayersToMap(
      source,
      PerformanceInfosConfig.layerConfigs,
      rootState.map
    );
  },
};
